import type { FunctionComponent } from "react";
import { useState } from "react";

import MyNewsIconFollowPackageAdd from "./my_news_icon_follow_package_add.png";
import { Container, IconSelect, Image, Text } from "./styles";
import TickIcon from "./tick.svg";

interface Props {
  onClick: (code: string, isSelected: boolean) => void;
  packageName: string;
}

export const MyNewsInitFollowPackagesItem: FunctionComponent<Props> = ({
  onClick,
  packageName,
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const handleClick = () => {
    const status = !isSelected;
    setIsSelected(status);
    onClick(packageName, status);
  };
  return (
    <Container $isSelected={isSelected} onClick={handleClick}>
      <Image alt="" src={MyNewsIconFollowPackageAdd.src} />
      <Text>{packageName}</Text>
      {isSelected ? <TickIcon /> : <IconSelect />}
    </Container>
  );
};

MyNewsInitFollowPackagesItem.displayName = "MyNewsInitFollowPackagesItem";
